<div mat-dialog-header>
  <h1>Unit History Report</h1>
</div>
<div mat-dialog-content class="dialog-content">
  <label class="w-100">Date Range</label>
  <mat-form-field>
    <input
      matInput
      placeholder="Start Date"
      [matDatepicker]="picker1"
      [(ngModel)]="startDate"
    />
    <mat-datepicker-toggle matSuffix [for]="picker1" />
    <mat-datepicker #picker1 />
  </mat-form-field>
  <span class="mx-5">To</span>
  <mat-form-field>
    <input
      matInput
      placeholder="End Date"
      [matDatepicker]="picker2"
      [(ngModel)]="endDate"
    />
    <mat-datepicker-toggle matSuffix [for]="picker2" />
    <mat-datepicker #picker2 />
  </mat-form-field>
</div>
<div class="buttons">
  <button
    type="button"
    class="pull-right"
    mat-raised-button
    color="primary"
    [disabled]="!startDate || !endDate"
    (click)="downloadUnitHistoryReport()"
  >
    Download Report
  </button>
  <button
    type="button"
    class="pull-right me-3"
    mat-button
    color="warn"
    (click)="close()"
  >
    Cancel
  </button>
</div>
